/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import Card from 'components/Card';
import { NON_LHI_SOURCES, IFI_PHONE_NUMBER, SPIG_PHONE_NUMBER } from 'config/constants';
import S from '../styles.scss';

const InProgressCallScript = (props) => {
  const { title, customerAnswered, source } = props;
  const didAnswer = customerAnswered === 'yes';
  const lhiPhase = !NON_LHI_SOURCES.includes(source);
  const ifiPhase = source === 'IFI';
  return (<Card className={S.card}>
    <div className={S.headerContainer}>
      <h4 className={S.title}>{`${title} ${didAnswer ? 'Answered' : 'Voicemail'}`} Script</h4>
    </div>
    <div className={S.scriptContainer}>
      {ifiPhase ? (<Fragment>
        {didAnswer ? (<Fragment>
          <p>I am calling regarding your installation; just wanted to check in to see how everything was going and if you have any questions?</p>
          <br />
          <p className={S.scriptUserNote}>-Wait for response-</p>
          <br />
          <p className={S.scriptUserNote}>IF NO TO QUESTIONS/CONCERNS:</p>
          <p>Great, if you do have any questions or concerns give us a call at {IFI_PHONE_NUMBER}. We&apos;re always happy to help. Have a great day!</p>
          <br />
          <p className={S.scriptUserNote}>IF YES TO QUESTIONS/CONCERNS:</p>
          <p><em>Respond to their question and offer a solution if possible.</em></p>
          <br />
          <p><em>*If it&apos;s something you need to look into further:</em></p>
          <p>I&apos;ll get the answers and follow up with you shortly. In the meantime, if anything else comes up, don&apos;t hesitate to give us a call at {IFI_PHONE_NUMBER}. Thank you!</p>
        </Fragment>) : (<p>
          I am calling regarding your installation; just wanted to check in to see how everything was going and if you have any questions or concerns. If you do please do not hesitate to give us a call back at {IFI_PHONE_NUMBER}. Thank you!
        </p>)}
      </Fragment>) : (<Fragment>
        <p>
          I want to check in and make sure that the installers have arrived and everything is going well so far.
        </p>
        <br />
        {didAnswer ? (<Fragment>
          <p className={S.scriptUserNote}>USER NOTE: Pause and allow the customer to respond.</p>
          <br />
          <p>Do you have any questions or concerns about your installation at this time?</p>
          <br />
          {lhiPhase && <p>
            That{'\''}s great! Also, when the installation is complete, we will reach out again to follow up on your overall satisfaction.
            Has anyone mentioned the survey to you yet?
          </p>}
          <br />
          <p className={S.scriptUserNote}>USER NOTE: Pause and allow the customer to respond.</p>
          <br />
          <p>
            Okay, great! Just a reminder, if at any time during your installation process you do not feel we are earning 10s, please reach out so we can continue to improve our services.
          </p>
          <br />
          {lhiPhase && <Fragment>
            <p>
              After your installation is complete, Lowe{'\''}s will reach out either by text or email to survey your experience. They will ask about our craftsmanship, our professionalism, and your likelihood to recommend to family and friends. <br />
              We strive for 10s, as they are the only passing score. If at any time during your installation process you do not feel we are earning 10s, please reach out so we can continue to improve our services.
            </p>
            <br />
          </Fragment>}
          <p>
           Do you have any questions for us at this time?
          </p>
          <br />
          <p>
           Do you have our Customer Care Line in case you need anything during or after your installation?
          </p>
          <br />
          <p>
           We look forward to completing your project and hope you have a great day!
          </p>
        </Fragment>) : (<p>
          If you have any questions or need anything during your installation,
          please call us back at {SPIG_PHONE_NUMBER}.
        </p>)}
        <br />
        <p>Thank you and have a great day!</p>
      </Fragment>)}
    </div>
  </Card>);
};

InProgressCallScript.propTypes = {
  title: PropTypes.string,
  customerAnswered: PropTypes.string,
  source: PropTypes.string,
};

export default InProgressCallScript;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseCommunications/components/inProgressCallScript.jsx